import {css, html, LitElement} from "lit";
import {PropertyValues} from "@lit/reactive-element";
import AdFormService from "../../services/AdFormService";
import {Section} from "../../services/Section";

export class WlBanner extends LitElement {
    protected encodedGoTo: string;
    private readonly section: string;
    private readonly pageviewId: string;
    private readonly operationType: string;
    private adFormService: AdFormService;

    static get properties() {
        return {
            encodedGoTo: {type: String, attribute: "data-g"},
            section:{type: String, attribute: "data-s"},
            pageviewId:{type: String, attribute: "data-pvi"},
            operationType:{type: String, attribute: "data-ot"},
        };
    }

    constructor() {
        super()
        this.encodedGoTo = "";
        this.section = "";
        this.pageviewId = "";
        this.operationType = "";
        this.adFormService = new AdFormService();
        this.addEventListener('click', this._goToLink);
    }

    static get styles() {
        return [css `
            :host {
                display: none;
                margin: 0 auto;
                cursor: pointer;
                width: fit-content;
            }
            :host([mobile]) {
                display: block;
            }
            @media only screen and (min-width: 1024px) {
                :host([mobile]) {
                    display: none;
                }
                :host([desktop]) {
                    display: block;
                }
            }
        `]
    }

    render() {
        return html`
            <slot />
        `
    }

    firstUpdated(args: PropertyValues) {
        super.firstUpdated(args);
        this.trackBannerImpression();
    }

    private _goToLink() {
        window.open(this._decodeGoTo());
    }

    private _decodeGoTo() {
        return atob(this.reverseEncodedGoTo());
    }

    private reverseEncodedGoTo() {
        return this.encodedGoTo.split('').reverse().join('');
    }

    private trackBannerImpression() {
        if (this.section == '' || window.mortgageBannerImpressionSent) {
            return;
        }
        let sectionValues = Object.values(Section.valueOf());
        let sectionObject: Section = sectionValues.filter(sectionValue => sectionValue === this.section)[0]
        if (!sectionObject) {
            return;
        }
        this.adFormService.impression(this.pageviewId, sectionObject, [], this.operationType);
        window.mortgageBannerImpressionSent = true;
    }
}

declare global {
    interface Window {
        mortgageBannerImpressionSent: boolean;
    }
}
